module.exports = __webpack_public_path__ + "static/media/unionbank.9f419442.webp";